export default {
  logout: "退出",
  login: "登录",
  loginSuccess: "登录成功",
  logoutSuccess: "退出成功",
  noData: "暂无数据",
  action: "操作",
  add: "添加{val}",
  del: "删除{val}",
  edit: "编辑{val}",
  search: "搜索",
  sort: "排序",
  pleaseSelect: "请选择{val}",
  pleaseEnter: "请输入{val}",
  yes: "是",
  no: "否",
  service: "电销管理后台",
  update: "更新",
  changePassword: "更改密码",
  changeUploadError: "请上传正确的图片格式",
  minLength: "最小长度为{val}位",
  resetPasswords: "重置密码",
  rememberPassword: "记住密码",
  send: "发送",
  inputUsername: "请输入用户名",
  inputPassword: "请输入密码",
  copySuccess: "复制成功",
  connecting: "正在连接...",
  networkUnstable: "网络不稳定，正尝试重连...",
  password: "密码",
  online: "在线",
  offline: "离线",
  busy: "忙碌",
  light: "亮白",
  dark: "暗黑",
  refresh: "刷新",
};
